import { render, staticRenderFns } from "./CardPosition.vue?vue&type=template&id=040a265b&scoped=true&"
import script from "./CardPosition.vue?vue&type=script&lang=js&"
export * from "./CardPosition.vue?vue&type=script&lang=js&"
import style0 from "./CardPosition.vue?vue&type=style&index=0&id=040a265b&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "040a265b",
  null
  
)

export default component.exports